import React from 'react';
import { ExpenseClaimProvider } from '../../context/ExpenseClaimProvider';
import { ExpenseClaimUtilProvider } from '../../context/ExpenseClaimUtilProvider';
import EmployeeExpenseClaims from './EmployeeExpenseClaims';

export default function EmployeeExpenseClaimsWrapper() {
  return (
    <ExpenseClaimUtilProvider>
      <ExpenseClaimProvider>
        <EmployeeExpenseClaims />
      </ExpenseClaimProvider>
    </ExpenseClaimUtilProvider>
  );
}
